import * as _ from 'lodash';
import { utils } from '@blend/ui-common';
import * as globalWrappers from './globalWrappers';
const { sentryConfig } = utils;

export function getCurrentUser() {
  return globalWrappers.getWindow().CURRENT_USER;
}

export function setCurrentUser(user: User) {
  window.CURRENT_USER = user;
  sentryConfig.setUserContext(getLoggableUser(user));
}

export function getDisplayName() {
  const user = getCurrentUser();
  return _.get(user, 'firstName');
}

export function getLoggableUser(user: User) {
  const piiFreeProperties = ['_id', 'appRole', 'acceptedTermsAt', 'lockout', 'lastLogin', 'roleIds', 'source'];
  return _.pick(user, piiFreeProperties);
}
